import * as React from 'react'
import { cn } from './utils'
import { Skeleton } from './skeleton'

type Variant = 'pulse' | 'shimmer' | 'wave' | 'none'

export interface AnimatedSkeletonProps extends React.ComponentProps<'div'> {
  variant?: Variant
}

/**
 * AnimatedSkeleton wraps shadcn/ui Skeleton and applies an animation variant.
 * - 'pulse'    → tailwind animate-pulse (default)
 * - 'shimmer'  → relies on `.skeleton-shimmer` class (already used in codebase)
 * - 'wave'     → `.skeleton-wave` if present (optional)
 * - 'none'     → no animation
 */
export function AnimatedSkeleton({ variant = 'pulse', className, ...props }: AnimatedSkeletonProps) {
  const animClass =
    variant === 'pulse' ? 'animate-pulse' :
    variant === 'shimmer' ? 'skeleton-shimmer animate-none' :
    variant === 'wave' ? 'skeleton-wave animate-none' :
    'animate-none'

  return <Skeleton className={cn(animClass, className)} {...props} />
}
